import { LogoMark } from "./Logo";

const words = ["Curiosity", "Science", "Skepticism", "Wonder"];

const Row = () => (
  <div className="flex shrink-0 items-center gap-10 pr-10">
    {[...words, ...words].map((w, i) => (
      <span key={i} className="flex items-center gap-10">
        <span className={`font-display uppercase font-bold text-5xl sm:text-7xl ${i % 2 ? "outline-text" : "text-white"}`}>{w}</span>
        <LogoMark className="w-8 h-8 text-lime" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="marquee" className="relative border-y border-white/10 py-8 overflow-hidden bg-ink">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
